import styled from 'styled-components'

export const ChallengeContainerBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`

export const ChallengeCardSpacing = styled.div`
  margin: 1.95rem;
`
